import React from 'react';

import { PageTitle } from '../../../components';
import { Destinations } from '../../../sections';



const DestPage = () => {
  return (
    <>

      {/* Page Title */}
      <PageTitle title={'Destinations'} page={'Destinations'} />

      {/* Destinations Section */}
      <Destinations />

    </>
  );
}

export default DestPage;